export default __webpack_public_path__ + "static/media/03_photo.d14e545e.jpg";